import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Images from '../images'
import { useNavigate, useOutletContext } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SignIn from "./SignIn";
import axiosInstance from "../Help/AxiosLogicInstance";
import "./ApplicationBanner.css";
const AcademicResearch = () => {
 const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [formSource, setFormSource] = useState("");
  const [showSignIn, setShowSignIn] = useState(false);
  const location = useLocation();
   const [hoveredCard, setHoveredCard] = useState(null);
         const { setActiveModal } = useOutletContext();
  const [isFormActive, setIsFormActive] = useState(false);
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const StepCard = ({ n, title, children }) => (
  <div className="col-12">
    <div className="card-step h-100 p-4">
      <div className="step-content">
        <h5 className="step-title mb-2">
          <span className="green">Step {n}:</span> {title}
        </h5>
        {children}
      </div>
    </div>
  </div>
);

const InfoList = ({ items, iconClass = "text-info" }) => (
  <ul className="ps-3 list-unstyled mb-0">
    {items.map((item, i) => (
      <li key={i}>
        <i className={`fa fa-info-circle ${iconClass} me-2`}></i>
        {item}
      </li>
    ))}
  </ul>
);
  
 const contacts = [
   {
     id: 1,
     title: "Registration & Application",
     email: "application@med-engage.com",
     gradient: "lightblue",
     icon: "📋",
     description: "Start your medical journey with us",
   },
   {
     id: 2,
     title: "Support & Contact",
     email: "support@med-engage.com",
     gradient: "lightgreen",
     icon: "🚀",
     description: "Get help when you need it",
   },
   {
     id: 3,
     title: "Academics",
     email: "academics.sciencecell@metropolisindia.com",
     gradient: "lightpink",
     icon: "🎯",
     description: "Academic excellence support",
   },
 ];
 const teamMembers = [
   {
     id: 1,
     name: "Shalini Sahay",
     email: "shalini.sahay@metropolisindia.com",
     phone: "+91 9310554590",
     gradient: "lightcoral",
     avatar: "SS",
     role: "Team Lead",
   },
   {
     id: 2,
     name: "Jeyasingh B",
     email: "jeyasingh.b@metropolisindia.com",
     phone: "+91 8928286168",
     gradient: "lightseagreen",
     avatar: "JB",
     role: "Secondary Contact",
   },
 ];

const faqs = [
  // About the Grant
  {
    question: "What is the MedEngage Academic Research Grant?",
    answer:
      "It is a Corporate Social Responsibility (CSR) initiative of Metropolis Healthcare Limited. It funds short-term research projects of two to three months, carried out by medical students under the guidance of a faculty mentor.",
  },
  {
    question: "How long should a project take?",
    answer:
      "A project should take about two to three months. Every project must be completed within the FY 2026–27 CSR cycle, which closes on 31 March 2027. This includes submission of the report, data and manuscript.",
  },

  // Eligibility
  {
    question: "Who can apply?",
    answer:
      "Students currently pursuing MBBS (including interns), MD/MS or DNB at a recognised medical college or hospital in India.",
  },
  {
    question: "Can I apply if I have already completed MBBS?",
    answer:
      "You must be enrolled in an eligible programme at the time of application. Please check the current Grant Call for this cycle’s student-status criteria.",
  },
  {
    question: "Do I need a faculty mentor?",
    answer:
      "Yes. Your application must name a faculty mentor who endorses the proposal and oversees the work. The mentor should normally be from your own institution. Any exception needs prior approval from the MedEngage team.",
  },
  {
    question: "Can I apply as a team?",
    answer: "No. Applications are accepted from individual students only.",
  },
  {
    question: "How many proposals can I submit?",
    answer: "You may submit one proposal per grant cycle.",
  },
  {
    question: "If I won last year, can I apply again in a subsequent year?",
    answer: "Yes. Previous recipients may apply again in a subsequent cycle.",
  },
  {
    question: "Can I apply for both a scholarship and a research grant?",
    answer: "No. Only one application per student is permitted.",
  },

  // Proposal and Application
  {
    question: "Is there a template for submitting the research proposal?",
    answer:
      "Yes. A Research Grant template is provided, and all applicants must use it to present their research.",
  },
  {
    question: "What makes a proposal eligible?",
    answer: (
      <>
        <p className="mb-2">A proposal should have:</p>
        <ul className="mb-0">
          <li>A clearly defined research question</li>
          <li>Academic, clinical or public-health relevance</li>
          <li>A sound, feasible methodology</li>
          <li>A defined study population, where applicable</li>
          <li>Appropriate outcome measures</li>
          <li>A realistic two-to-three-month timeline</li>
          <li>A justified budget within the grant amount</li>
        </ul>
      </>
    ),
  },
  {
    question: "Are there preferred research themes?",
    answer:
      "No. Applicants may choose their own research theme, in consultation with their faculty mentor. The research must be beneficial to the health domain.",
  },
  {
    question: "What is the process after I submit my application?",
    answer: (
      <>
        <p className="mb-2">
          Every application goes through a structured, multi-stage review:
        </p>
        <ol className="mb-0">
          <li>
            <strong>Screening:</strong> A jury of eminent experts reviews the
            submitted research idea. Based on its recommendation, shortlisted
            proposals move to Round 2.
          </li>
          <li>
            <strong>Notification:</strong> Shortlisted students are notified
            about Round 2.
          </li>
          <li>
            <strong>Presentation:</strong> Each shortlisted student presents the
            research idea online for 15 minutes, followed by questions from the
            jury.
          </li>
          <li>
            <strong>Selection:</strong> Based on the jury’s recommendation after
            the presentation, proposals are selected for grant support. The
            decision of the jury is final and binding.
          </li>
        </ol>
      </>
    ),
  },
  {
    question: "Which proposals may be rejected?",
    answer: (
      <>
        <p className="mb-2">A proposal may be rejected if it:</p>
        <ul className="mb-0">
          <li>Is incomplete or ineligible</li>
          <li>Lacks a clear research question or a sound methodology</li>
          <li>Is commercial in nature</li>
          <li>Largely duplicates existing work</li>
          <li>Cannot realistically be completed within the grant period</li>
          <li>Does not meet ethical requirements</li>
          <li>Is submitted after the deadline</li>
        </ul>
      </>
    ),
  },
  {
    question: "How do I apply?",
    answer:
      "Register on the official MedEngage online portal and submit the application form within the notified application period. Only complete applications received before the deadline are considered.",
  },
  {
    question: "What documents do I need?",
    answer: (
      <>
        <p className="mb-2">You will need:</p>
        <ul className="mb-0">
          <li>Completed online application form</li>
          <li>Research proposal or synopsis in the prescribed template</li>
          <li>Student ID or enrolment proof</li>
          <li>Details of your college or institution</li>
          <li>Faculty mentor details and endorsement</li>
          <li>Methodology and proposed timeline</li>
          <li>Budget with justification</li>
          <li>Ethics approval or its status, where applicable</li>
          <li>Signed applicant declaration</li>
          <li>Bank details, for transferring funds if you are selected</li>
          <li>Any other document listed in the Grant Call</li>
        </ul>
      </>
    ),
  },
  {
    question: "Can I edit my application after submitting it?",
    answer:
      "No. An application cannot be edited once it has been submitted, so please review it carefully before submitting.",
  },

  // Evaluation and Selection
  {
    question: "How are proposals evaluated?",
    answer: (
      <>
        <p className="mb-2">
          Proposals are evaluated in two stages. First, administrative screening
          checks eligibility, completeness, institutional affiliation, mentor
          details, feasibility, budget and declarations. Eligible proposals then
          go to a scientific review, scored as follows:
        </p>
        <div className="table-responsive">
          <table className="table table-sm table-bordered align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Criterion</th>
                <th className="text-end">Weight (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Methodology and study design</td><td className="text-end">25</td></tr>
              <tr><td>Research question and relevance</td><td className="text-end">20</td></tr>
              <tr><td>Scientific rationale and originality</td><td className="text-end">15</td></tr>
              <tr><td>Feasibility within two to three months</td><td className="text-end">15</td></tr>
              <tr><td>Expected academic or health relevance</td><td className="text-end">15</td></tr>
              <tr><td>Budget and mentor support</td><td className="text-end">10</td></tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    question: "Who reviews the applications?",
    answer: "An external jury of subject experts, appointed by Metropolis.",
  },
  {
    question: "Is the jury’s decision final?",
    answer:
      "Yes. The jury’s decision is final and binding. Meeting the eligibility criteria does not guarantee funding; selection is competitive.",
  },
  {
    question: "How will I know if I have been selected?",
    answer:
      "You will receive a Grant Award email. It sets out your project title, grant amount, grant period, approved budget, reporting requirements, and the conditions for using the funds and closing the project.",
  },

  // Grant Amount and Use of Funds
  {
    question: "How much is the grant?",
    answer: "The amount is announced in the Grant Call for each cycle.",
  },
  {
    question: "How will I receive the funds?",
    answer: (
      <>
        <p className="mb-2">
          Funds are transferred to the principal investigator’s bank account once
          correct bank details have been submitted. They may be released in one
          or more instalments. The following details are required:
        </p>
        <ul className="mb-0">
          <li>Name as per bank records</li>
          <li>Bank name, branch and address</li>
          <li>Account number</li>
          <li>IFSC code</li>
          <li>PAN or Aadhaar number</li>
        </ul>
      </>
    ),
  },
  {
    question: "If I am selected but decide not to accept the funds, what should I do?",
    answer:
      "Please inform the MedEngage team immediately so that the grant can be offered to the next applicant in the larger interest of research.",
  },
  {
    question: "What can the grant be spent on?",
    answer: (
      <>
        <p className="mb-2">
          Only costs directly linked to your approved project and budget, such
          as:
        </p>
        <ul className="mb-0">
          <li>Research consumables</li>
          <li>Data collection</li>
          <li>Research-related investigations</li>
          <li>Field expenses</li>
          <li>Statistical support</li>
          <li>Printing and research materials</li>
          <li>Publication costs, with Metropolis’s permission</li>
          <li>Other costs approved by MedEngage</li>
        </ul>
      </>
    ),
  },
  {
    question: "What can the grant not be spent on?",
    answer:
      "The grant cannot be used for personal expenses, tuition fees, salaries, travel unrelated to the research, or anything outside the approved budget. Significant budget changes need prior written approval. Any unspent amount must be reported and may have to be refunded.",
  },
  {
    question: "Can I accept other funding for the same project?",
    answer:
      "You must disclose any other funding for the project. Funding the same expense twice is not permitted unless explicitly approved.",
  },

  // Ethics and Compliance
  {
    question: "Do I need Ethics Committee approval?",
    answer:
      "Yes, if your research involves human participants, patient data, biological samples or identifiable information. You must obtain approval from your Institutional Ethics Committee before starting. Grant approval from Metropolis does not replace it. You and your mentor are jointly responsible for ethical compliance, including participant privacy.",
  },
  {
    question: "Can I change my project after approval?",
    answer:
      "Any significant change needs prior approval from MedEngage and, where relevant, your Ethics Committee. This covers changes to the objective, method, sample, site, budget, timeline or ethical procedures.",
  },
  {
    question: "What counts as research misconduct?",
    answer: (
      <>
        <p className="mb-2">Research misconduct includes:</p>
        <ul className="mb-2">
          <li>Plagiarism</li>
          <li>Fabricating or falsifying data</li>
          <li>Misrepresenting findings</li>
          <li>Duplicate publication</li>
          <li>Unethical authorship</li>
          <li>Misuse of funds</li>
          <li>Submitting false information or documents</li>
        </ul>
        <p className="mb-0">
          Metropolis may suspend or end the grant and recover any funds that were
          misused.
        </p>
      </>
    ),
  },

  // Monitoring and Reporting
  {
    question: "How will my progress be monitored?",
    answer: (
      <>
        <p className="mb-2">
          Monitoring is light, given the short duration of the projects, and is
          desk-based or virtual:
        </p>
        <ul className="mb-0">
          <li><strong>At the start:</strong> confirmation that the project has begun, your final protocol and any ethics approval</li>
          <li><strong>During the project:</strong> brief updates, if requested</li>
          <li><strong>At completion:</strong> your final report and a statement of expenditure</li>
        </ul>
      </>
    ),
  },
  {
    question: "When is the final report due, and what should it include?",
    answer: (
      <>
        <p className="mb-2">
          The final report is due in February or the first week of March 2027.
          MedEngage will confirm the exact date. It should include:
        </p>
        <ul className="mb-2">
          <li>Your full report</li>
          <li>An abstract</li>
          <li>Key results and conclusions</li>
          <li>A statement of expenditure</li>
          <li>Any research output, such as a poster, presentation or manuscript</li>
        </ul>
        <p className="mb-0">
          The project closes once these are reviewed and accepted.
        </p>
      </>
    ),
  },
  {
    question: "Can I get an extension?",
    answer:
      "Extensions are not normally granted, as the grant runs within the CSR cycle. If you expect a delay, please inform the MedEngage team at once, with the reason and a revised plan.",
  },

  // Publication
  {
    question: "Can I publish or present my findings?",
    answer: (
      <>
        <p className="mb-2">
          Yes, and you are encouraged to do so, subject to your institution’s
          requirements. Metropolis will not influence your findings. Funding does
          not guarantee that a journal or conference will accept your work.
          Please acknowledge the support as follows:
        </p>
        <blockquote className="fst-italic border-start border-success border-3 ps-3 mb-0">
          “This research, titled ‘[Title of Research]’, was supported by the
          Corporate Social Responsibility (CSR) funds of Metropolis Healthcare
          Limited. The authors gratefully acknowledge Metropolis Healthcare
          Limited for its support towards this research.”
        </blockquote>
      </>
    ),
  },
];
  // ✅ useState instead of React.useState
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);
 const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

    useEffect(() => {
        document.title = "Academic Research Support - MedEngage";
      }, []);
  useEffect(() => {
    const fetchFormSettings = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/1');
        if (response.data.Status === '200' && response.data.Data && response.data.Data.length > 0) {
          const isActive = response.data.Data.some(item => item.IsActive);
          setIsFormActive(isActive);
        }
      } catch (error) {
        console.error('Error fetching form settings:', error);
      }
    };
    fetchFormSettings();
  }, []);
  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">AcademicResearch</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                  <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>Academic Research</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                   Supporting medical {" "}
                    <span>
                      <strong className="green">
                        {" "}
                        Research and Innovation in Healthcare
                      </strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                  Research drives progress in healthcare. To empower the next generation of medical researchers to turn ideas into evidence, Metropolis Healthcare, through its CSR arm, the Metropolis Foundation, supports academic research across India. 
                    
                  </p>

                  <p className="ul-section-descr">
                    Through the{" "}
                    <strong>
                      Metropolis MedEngage Academic Research and Innovation
                      Grant
                    </strong>
                    , medical students across India can apply for funding to pursue research in the medical sciences. Projects may be undertaken at any recognised institute, college or hospital of the student’s choice, subject to the guidance and approval of a project mentor.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper text-center">
                    <img
                      src={Images.academy}
                      alt="Observership Program"
                      className="scholarship-image rounded-3"
                    />
                    <div className="img-caption mt-2">Supporting the next generation of medical researchers in India</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

    <section className="ul-about ul-section-spacing">
  <div className="medengage-upgrade ul-container">
    <h3 className="ul-section-title text-center">
      What the <span className="version green">grant offers</span>
    </h3>

    <p className="upgrade-text">
      India needs more homegrown medical research. In alignment with the
      national vision of{" "}
      <span className="highlight-text">
        Jai Anusandhan (research and innovation)
      </span>
      , MedEngage provides research grants to medical students to support
      unique and innovative projects in medical science with measurable
      clinical impact.
    </p>

    <p className="upgrade-text">
      In addition to financial support, Metropolis Healthcare's in-house
      subject matter experts will provide mentorship and share insights into
      the latest advancements in laboratory medicine. This guidance will help
      students design impactful research studies with the potential for
      publication in national and international journals.
    </p>
  </div>
</section>

       <section className="section-spacing bgg-light ul-section-spacing">
  <div className="container">
    <div className="text-center mb-5 px-3">
      <h3 className="ul-section-title text-center">
        Eligibility <span className="version green">and guidelines</span>
      </h3>
      <p className="section-subtitle">MedEngage Academic Research Grant 2026-27</p>
      <p className="mx-auto" style={{ maxWidth: "68ch" }}>
        The grant supports short research projects, about two to three months
        long, led by medical students in India. Here is how it works, from
        application to final report.
      </p>
    </div>

    <div className="row g-4 mb-5">
      <StepCard n={1} title="Check your eligibility">
        <p className="mb-2">
          The grant is open to allopathic medical students pursuing MBBS, MD/MS
          or DNB, including interns, at a recognised medical college or hospital
          in India. You will need a faculty mentor at your institution to guide
          your research.
        </p>
        <p className="mb-0">
          <span className="fw-bold text-danger">Please note:</span> research on
          laboratory diagnostics is not eligible under our CSR guidelines.
        </p>
      </StepCard>

      <StepCard n={2} title="Register and apply">
        <p className="mb-0">
          Register on the <strong className="green">MedEngage</strong> portal and
          complete the online application form. Please fill in every field, as
          we cannot consider incomplete applications.
        </p>
      </StepCard>

      <StepCard n={3} title="Share your research idea">
        <p className="mb-2">
          Describe your research idea in up to{" "}
          <strong className="green">500 words</strong> using the{" "}
          <a
            href="/Research Proposal Template_Metropolis.pptx" /* replace with the new template file */
            target="_blank"
            rel="noopener noreferrer"
            className="text-success fw-bold text-decoration-underline"
          >
            research proposal template
          </a>
          . Upload it along with:
        </p>
        <InfoList
          items={[
            "Proof of enrolment",
            "Your mentor’s endorsement",
            "Your proposed timeline and budget",
            "Your ethics approval status, where applicable",
          ]}
        />
      </StepCard>

      <StepCard n={4} title="Screening and selection">
        <p className="mb-0">
          We first check each application for eligibility and completeness. An
          expert jury then reviews the shortlisted proposals for relevance,
          originality, methodology, feasibility and budget. The jury’s decision
          is final.
        </p>
      </StepCard>

      <StepCard n={5} title="Confirm your grant">
        <p className="mb-2">
          If you are selected, the MedEngage team will email you. Please reply
          to confirm. We will try to reach you up to three times, and if we do
          not hear back, the grant may be offered to another applicant.
        </p>
        <p className="mb-0">
          You will then submit your full research proposal, covering the
          problem, objectives, work plan, expected outcomes and budget. If your
          study needs Ethics Committee approval, please secure it before you
          begin.
        </p>
      </StepCard>

      <StepCard n={6} title="Carry out your research">
        <p className="mb-0">
          Conduct your research as approved and share progress updates when we
          ask. If you need to make a significant change to the project, please
          check with us first.
        </p>
      </StepCard>

      <StepCard n={7} title="Submit your final report">
        <p className="mb-0">
          Send us your completed report or manuscript, research data and
          statement of expenditure by{" "}
          <strong className="green">February 2027</strong>. Your project closes
          once we have reviewed and accepted these.
        </p>
      </StepCard>

      <StepCard n={8} title="How the grant is released">
        <p className="mb-2">
          The research grant will be disbursed in two equal instalments directly
          into the Principal Investigator’s bank account:
        </p>
        <InfoList
          items={[
            <>
              <span className="fw-bold green">First instalment – 50%:</span>{" "}
              Released upon approval of the research proposal.
            </>,
            <>
              <span className="fw-bold green">Second instalment – 50%:</span>{" "}
              Released upon submission and acceptance by Metropolis Healthcare
              Limited of the research status report, manuscript, research data,
              and statement of expenditure.
            </>,
          ]}
        />
        <p className="mt-3 mb-3">
          <span className="fw-bold text-danger">Important:</span> Submission of
          the required research report and supporting documents is mandatory for
          the release of the second instalment. Failure to submit the research
          report will result in cancellation of the research grant.
        </p>
        <p className="fw-semibold mb-2">Bank details required</p>
        <InfoList
          items={[
            "Name as in Bank",
            "Name of the Bank",
            "Branch Name",
            "Account Number",
            "IFSC Code",
            "Bank Address",
            "PAN Number / Aadhaar Number details will be collected once your proposal is selected.",
          ]}
        />
      </StepCard>

      {/* Please note */}
      <div className="col-12">
        <div className="card-step h-100 p-4">
          <div className="step-content">
            <h5 className="step-title mb-2">Please note</h5>
            <ul className="ps-3 list-unstyled mb-0">
              <li>
                <i className="fa fa-info-circle text-danger me-2"></i>
                Research pertaining to <strong>laboratory diagnostics</strong>{" "}
                will not be considered, in line with{" "}
                <strong>CSR compliance</strong> requirements.
              </li>
              <li>
                <i className="fa fa-info-circle text-warning me-2"></i>
                The student/doctor must be registered under{" "}
                <strong className="green">MedEngage</strong> and formally apply
                by filling out the online{" "}
                <strong>academic research grant application form</strong>.
              </li>
              <li>
                <i className="fa fa-info-circle text-info me-2"></i>
                <span className="fw-bold text-info">Duration:</span> The
                research grant application process will align with the{" "}
                <strong>CSR cycle</strong>.
              </li>
              <li>
                <i className="fa fa-info-circle text-secondary me-2"></i>
                <strong>Management’s decision</strong> will be final and binding.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        <section className="ul-about ul-section-spacing d-none">
          <div className="ul-container application-banner">
            <div className="row align-items-center">
              {/* Left Illustration */}
              <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
                <img
                  src={Images.academicvector}
                  alt="scholar-vector"
                  className="img-fluid"
                />
              </div>

              {/* Right Text */}
              <div className="col-md-6 banner-text text-center text-md-start">
                <h2 className="mb-2 fw-bold">Academic Research Program</h2>
                <p className="mb-3">
                  Apply now and take your first step to success.
                </p>

                <div className="d-flex flex-column flex-sm-row align-items-center gap-2 justify-content-center justify-content-md-start">
                  {isFormActive && (
                    <>
                      {token ? (
                        <button
                          className="btn-login"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/academic-research-application/");
                          }}
                        >
                          Apply
                        </button>
                      ) : (
                        <button
                          className="btn-login d-flex align-items-center gap-2"
                          onClick={() => {
                            setActiveModal("signIn");
                          }}
                        >
                          Login
                        </button>
                      )}
                    </>
                  )}

                  {showSignIn && (
                    <SignIn
                      show={showSignIn}
                      handleClose={() => setShowSignIn(false)}
                      from={formSource}
                    />
                  )}

                  {/* Arrow only visible on large screens */}
                  <img
                    src={Images.Arrow}
                    alt="arrow"
                    className="img-fluid d-none d-lg-inline-block ms-5"
                    style={{ transform: "rotate(70deg)" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ul-about ul-section-spacing">
  <div className="ul-container application-banner">
    <div className="row align-items-center">
      <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
        <img
          src={Images.academicvector}
          alt="Medical students discussing a research project"
          className="img-fluid"
          loading="lazy"
        />
      </div>

      <div className="col-md-6 banner-text text-center text-md-start">
        <h2 className="mb-2 fw-bold">MedEngage Academic Research Grant 2026-27</h2>
        <p className="mb-3">
          Have a research question worth answering? Apply for funding and
          expert mentorship.
        </p>
<div className="d-flex justify-content-center justify-content-md-start">
        <button
          className="btn-login"
          onClick={(e) => {
            e.preventDefault();
            if (token) navigate("/academic-research-application/");
            else setActiveModal("signIn");
          }}
        >
          {token ? "Apply" : "Login"}
        </button>
</div>
        {showSignIn && (
          <SignIn
            show={showSignIn}
            handleClose={() => setShowSignIn(false)}
            from={formSource}
          />
        )}
      </div>
    </div>
  </div>
</section>
        <section className="ul-section-spacing">
          <div className="container my-4 w-100">
            <div className="row justify-content-center">
              <div className="col-12 col-md-12">
                <div
                  className="alert alert-light border border-success rounded-3 p-4"
                  role="alert"
                >
                  <h5 className="alert-heading text-success">Important Note</h5>
                  <p className="mb-2">
                    MedEngage scholarship recipients must acknowledge receipt of the
                    scholarship funds upon notification by the Metropolis Healthcare
                    Limited (MHL) team. The MHL team will make up to three attempts to
                    contact each recipient. If a recipient remains unresponsive after
                    these attempts, MHL shall not be responsible for any unclaimed
                    scholarship funds.
                  </p>
                  <p className="mb-0">
                    All claims must be submitted by{" "}
                    <strong className="text-dark">31 March 2027</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="faq-section">
          <div className="ul-container">
            <h2 className="ul-section-title text-center p-2 m-2">FAQs</h2>
            <div className="faq-container">
              <div className="faq-grid">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ flex: 1 }}>
                      <span className="faq-question">{faq.question}</span>
                      <div
                        className={`faq-answer ${
                          openIndex === index ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {faq.answer}
                      </div>
                    </div>
                    <span className="faq-icon">
                      <img
                        src={openIndex === index ? Images.Minus : Images.Plus}
                        alt={openIndex === index ? "Minus" : "Plus"}
                      />
                    </span>
                  </div>
                ))}
              </div>
              {/* <div className="text-center mt-4">
            <button className="btn-view">View All</button>
          </div> */}
            </div>
          </div>
        </section>

        <section className="med-cards-section py-4 py-md-5">
          <div className="container-fluid px-3 px-md-5">
            {/* Department Contacts */}
            <div className="row g-2 g-md-2 mb-3 mb-md-5 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-4">
                <h2 className="fw-bold">
                  <span className="text-success">Contact</span> Information
                </h2>
                <div className="divider mx-auto"></div>
              </div>
              {contacts.map((contact, index) => (
                <div
                  key={contact.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card department-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`dept-${contact.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="contact-card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="icon-container"
                        style={{ background: contact.gradient }}
                      >
                        <span className="icon-emoji">{contact.icon}</span>
                        <div className="pulse-ring"></div>
                      </div>

                      <h6 className="card-title mb-2">{contact.title}</h6>
                      <p className="card-description text-muted">
                        {contact.description}
                      </p>

                      <div className="email-container">
                        <a
                          href={`mailto:${contact.email}`}
                          className="email text-success"
                          title={contact.email}
                        >
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Team Members */}
            <div className="row g-2 g-md-2 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-3">
                <div className="divider mx-auto"></div>
              </div>

              {teamMembers.map((member, index) => (
                <div
                  key={member.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card team-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`team-${member.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${(index + 3) * 0.1}s` }}
                  >
                    <div className="card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="avatar-container"
                        style={{ background: member.gradient }}
                      >
                        <span className="avatar-text">{member.avatar}</span>
                        <div className="avatar-ring"></div>
                      </div>

                      <h4 className="member-name mb-2">{member.name}</h4>

                      <div className="contact-info d-flex flex-column gap-1 w-100">
                        <div className="email-container">
                          <a
                            href={`mailto:${member.email}`}
                            className="email text-success"
                          >
                            {member.email}
                          </a>
                        </div>
                        {member.phone && (
                        <div className="email-container">
                          <a
                            href={`tel:${member.phone}`}
                            className="email text-dark"
                          >
                            {member.phone}
                          </a>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AcademicResearch